module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "wide": false,
      "width": "460px"
    },
    on: {
      "close": _vm.closeModal
    }
  }, [_c('div', {
    staticClass: "addon-image default-image",
    style: (_vm.params.addon.image ? 'background-image:url(https://static.booking.branasgruppen.se/static/svg/addons/' + _vm.params.addon.image + ');' : 'background-size: cover;')
  }), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.params.addon.arttext))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.params.addon.desc2))]), _vm._v(" "), (_vm.params.addon.included) ? _c('p', [_vm._v("1 st "), _c('span', {
    staticClass: "lowercase"
  }, [_vm._v(_vm._s(_vm.params.addon.arttext))]), _vm._v(" ingår alltid i ditt boende. Antalet du väljer är utöver det som redan ingår.")]) : _vm._e(), _vm._v(" "), (_vm.params.addon.auto !== 'T') ? _c('div', {
    staticClass: "buttons"
  }, [(!_vm.params.addon.added && _vm.params.addon.max_qty > 1) ? _c('span', {
    staticClass: "quantity"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.params.addon.qtySelected),
      expression: "params.addon.qtySelected"
    }],
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.params.addon.qtySelected)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.params.addon, "qtySelected", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("st")])]) : _vm._e(), _vm._v(" "), (_vm.params.addon.added) ? _c('button', {
    class: 'small ' + (_vm.params.addon.added ? 'green' : '') + '',
    on: {
      "click": function($event) {
        return _vm.removeArticle(_vm.params.addon)
      }
    }
  }, [_vm._v(_vm._s(_vm.params.addon.qtySelected) + "st valda")]) : _vm._e(), _vm._v(" "), (_vm.params.addon.added) ? _c('button', {
    class: 'small trash border',
    on: {
      "click": function($event) {
        return _vm.removeArticle(_vm.params.addon)
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "trash",
      "scale": 1.3
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.params.addon.added && !_vm.params.addon.rut) ? _c('button', {
    class: {
      small: true, disabled: !_vm.params.addon.qtySelected
    },
    on: {
      "click": function($event) {
        return _vm.chooseArticle(_vm.params.addon)
      }
    }
  }, [_vm._v("Välj")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.params.addon.auto === 'T') ? _c('p', [_vm._v("\n    " + _vm._s(_vm.params.addon.autoTextLong || 'Detta tillval är obligatoriskt för detta boende.') + "\n  ")]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e174130e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/AddonInfoModal.vue
// module id = 1032
// module chunks = 0